
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable, PLATFORM_ID, Inject, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { switchMap, catchError } from 'rxjs/operators'

import { FeatureProvider } from '../auth/feature.provider';
import { TokenProvider } from '../token/token.provider';
import { TokenState } from '../token/token.state';
import { ShellDomainProvider } from '../utility/shell-domain.provider';
import { UserInfoService } from './user-info.service';
import { isPlatformBrowser, Location } from '@angular/common';
import { EcapCookieService } from '../cookie/ecap-cookie.service';

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {
    private tokenStateObservable: BehaviorSubject<string>;
    isPlatformBrowser: boolean;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private tokenProvider: TokenProvider,
        private injector: Injector,
        private tokenState: TokenState) {
        this.isPlatformBrowser = isPlatformBrowser(this.platformId);
        this.tokenStateObservable = this.tokenState.getTokenStateObservable();
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.isPlatformBrowser) {
            const that = this;
            const featureProvider = this.injector.get(FeatureProvider);
            let dupReq: HttpRequest<any>;
            if (!this.tokenProvider.getAccessToken()) {
                dupReq = req.clone({
                    headers: req.headers.set('Origin', process.env.ORIGIN)
                });
            } else {
                dupReq = req.clone({
                    headers: req.headers.set('Authorization', 'bearer ' + this.tokenProvider.getAccessToken())
                        .set('Origin', process.env.ORIGIN)
                });
            }
            return next.handle(dupReq).pipe(
                catchError((err, caught) => {
                    if ((err.url && err.url.toLowerCase() === ShellDomainProvider['api'].Token.toLowerCase()) && err.status === 400) {
                        //console.log('interceptor: ITS TIME TO LOGOUT FROM SERVER SIDE');
                        that.tokenProvider.getAnnonymousToken().then((response: any) => {
                            that.tokenProvider.setAccessToken(response.access_token);
                            that.tokenProvider.setRefreshToken(response.refresh_token);
                            featureProvider.resetFeatures();
                            const router = this.injector.get(Router);

                            if (ShellDomainProvider['api']['NoAnnonymouslyAccess'])
                                router.navigate(['']);
                            else {
                                let route = router.url || "/";
                                router.navigate([route]);
                            }

                            return throwError('');
                        });
                        return throwError(err);
                    } else {
                        return this.tokenProvider.refreshTokenObservable().pipe(switchMap((newToken: any) => {
                            process.env.cookiesForResponseACCESS_TOKEN = newToken.access_token;
                            process.env.cookiesForResponseREFRESH_TOKEN = that.tokenProvider.getRefreshToken();
                            that.tokenProvider.setAccessToken(newToken.access_token);
                            const seconddupReq = dupReq.clone(
                                {
                                    headers: dupReq.headers.set('Authorization', 'bearer ' + this.tokenProvider.getAccessToken())
                                }
                            );
                            return next.handle(seconddupReq);
                        }));
                    }
                }));
        } else {
            const featureProvider = this.injector.get(FeatureProvider);
            return next.handle(req).pipe(catchError((err, caught) => {
                if (err.url && err.url.toLowerCase() === ShellDomainProvider['api'].Token.toLowerCase() && err.status === 400) {

                    const that = this;
                    if (err && err.error && err.error.error === 'site_is_not_registered') {
                        const router = this.injector.get(Router);
                        router.navigate(['/domian-registration']);  // NEED DOMAIN REGISTRATION PATH IN BUISSNESS ROUTE.TS
                    } else {
                        this.tokenProvider.getAnnonymousToken().then((response: any) => {
                            const userInfoService = this.injector.get(UserInfoService);
                            that.tokenProvider.setAccessToken(response.access_token);
                            that.tokenProvider.setRefreshToken(response.refresh_token);
                            that.tokenProvider.setRefreshTokenToCookie(response.refresh_token);
                            userInfoService.resetUserInfo();
                            featureProvider.resetFeatures();
                            
                            userInfoService.setLoggedInUser();
                            userInfoService.redirectToMasterSite(response);
                            this.tokenStateObservable.next('400_RECOVERED');

                            const router = this.injector.get(Router);
                            if (ShellDomainProvider['api']['NoAnnonymouslyAccess'])
                                router.navigate(['/']);
                            else {
                                this.tokenState.tokenStateEventEmitter.emit('400_DISCOVER');
                            }

                            return throwError('');
                        });

                        return throwError(err);
                    }

                } else if (err.status === 401) {
                    return this.tokenProvider.refreshTokenObservable().pipe(switchMap((newToken: any) => {
                        this.tokenStateObservable.next('401_RECOVERED');
                        return next.handle(req);
                    }));
                } else if (err.status === 500) {
                    return throwError(err);
                }
                else if (err && err.error && err.error.error === 'invalid_state_information') {
                    return next.handle(req);
                }
                else {
                    console.log('faced unknown error, aborting bootstraping process START...');
                    console.log(err);
                    console.log('faced unknown error, aborting bootstraping process END...');
                    sessionStorage.setItem(ShellDomainProvider['api'].SessionKey, 'hello');
                    return throwError(err);
                }
            }));
        }
    }

    public renewAccessToken(next, req) {
        next.handle(req);
    }
}
